import { useEffect } from "react";
import { Card, Modal, Select, Skeleton, Statistic, Tabs, Tooltip } from "antd";
import { ArrowUpOutlined } from "@ant-design/icons";
import { PiMicrosoftExcelLogoLight } from "react-icons/pi";
import "react-toastify/dist/ReactToastify.css";

import { ModalOrdemServico, ContainerTableServiço, ContainerTableOs } from "./styled";
import { BtnSkeleton, ContainerSearch, LoadingCircle, SkeletonContainer } from "../styledGlobalModal";
import HeaderSideHome from "./HeaderSideHome";
import PortalContadorOS from "./PortalContadorOS";
import TabelaOrdensServico from "./TabelaOrdensServico";
import { useOrdensServico } from "./useOrdensServico";

const TABS = [
  { key: "Pendentes", label: "Pendentes" },
  { key: "Processadas", label: "Processadas" },
];

const OPCOES_EXPORTACAO = [
  { value: "Pendentes", label: "Excel - OS Pendentes" },
  { value: "Processadas", label: "Excel - OS Processadas" },
  { value: "Todos", label: "Excel - OS Todas" },
];

export function OrdensServico() {
  const {
    loading,
    loadingExportExcel,
    osPendentes,
    osProcessadas,
    totalRegistroPendentes,
    totalRegistroProcessadas,
    activeTab,
    setActiveTab,
    page,
    quantidade,
    buscarPagina,
    buscarPorCliente,
    exportarExcel,
    numeroSolicitacao,
    isModalPortalContadorOS,
    setIsModalPortalContadorOS,
    openModals,
    alternarModal,
    abrirTratamento,
    msgErrorIdClient,
  } = useOrdensServico();

  // Notifica o iframe pai sobre a altura do conteúdo (portal embutido).
  useEffect(() => {
    window.parent.postMessage({ frameHeight: 1500, scrollTo: false }, "*");
  }, []);

  const listaAtiva = activeTab === "Pendentes" ? osPendentes : osProcessadas;
  const totalRegistroAtivo = activeTab === "Pendentes" ? totalRegistroPendentes : totalRegistroProcessadas;

  return (
    <>
      <ModalOrdemServico>
        <HeaderSideHome onSearch={buscarPorCliente} />

        <ContainerTableServiço>
          <ContainerTableOs>
            <ContainerSearch>
              <div>
                <div className="container-title">
                  <span>Ordens de serviço</span>
                </div>

                <div className="display-flex margin-button justify-content-right">
                  <Card variant="borderless">
                    <Statistic
                      title="Quantidade de registro por filtro"
                      value={totalRegistroAtivo || 0}
                      precision={2}
                      valueStyle={{ color: "#3f8600" }}
                      prefix={<ArrowUpOutlined />}
                    />
                  </Card>

                  <div className="display-flex">
                    <div className="margin-5" style={{ textAlign: "center", display: "flex", alignItems: "center" }}>
                      {loadingExportExcel ? (
                        <SkeletonContainer>
                          <LoadingCircle />
                          <BtnSkeleton />
                          <BtnSkeleton />
                        </SkeletonContainer>
                      ) : (
                        <>
                          <div className="margin-5">
                            <Tooltip title="Controle de Planilha">
                              <div className="bt-excel" onClick={() => exportarExcel()}>
                                <PiMicrosoftExcelLogoLight />
                              </div>
                            </Tooltip>
                          </div>

                          <div className="margin-5">
                            <Select
                              loading={loadingExportExcel}
                              disabled={loading}
                              defaultValue="Exportar"
                              style={{ width: 220 }}
                              onChange={exportarExcel}
                              options={OPCOES_EXPORTACAO}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </ContainerSearch>

            {loading ? (
              <SkeletonTable />
            ) : (
              <>
                <Tabs defaultActiveKey="Pendentes" items={TABS} onChange={setActiveTab} />
                <TabelaOrdensServico
                  isTable={listaAtiva.length > 0}
                  msgErrorIdClient={msgErrorIdClient}
                  loading={loading}
                  listTableFilter={listaAtiva}
                  handleTratar={abrirTratamento}
                  toggleModal={alternarModal}
                  openModals={openModals}
                  page={page}
                  quantidade={quantidade}
                  totalRegistro={totalRegistroAtivo}
                  handleChangePage={(_, novaPagina) => buscarPagina(novaPagina)}
                />
              </>
            )}
          </ContainerTableOs>
        </ContainerTableServiço>
      </ModalOrdemServico>

      <Modal open={isModalPortalContadorOS} width="95%" height="100%" onCancel={() => setIsModalPortalContadorOS(false)} footer={null}>
        <PortalContadorOS
          numeroSolicitacao={numeroSolicitacao}
          setIsModalPortalContadorOS={setIsModalPortalContadorOS}
          isModalPortalContadorOS={isModalPortalContadorOS}
        />
      </Modal>
    </>
  );
}

function SkeletonTable() {
  return (
    <>
      {[...Array(3)].map((_, index) => (
        <Skeleton key={index} variant="rectangular" width="100%" height={40} />
      ))}
    </>
  );
}

export default OrdensServico;
